import { render, staticRenderFns } from "./Wap_CZY005_Step2.vue?vue&type=template&id=13656a36&scoped=true&"
import script from "./Wap_CZY005_Step2.vue?vue&type=script&lang=js&"
export * from "./Wap_CZY005_Step2.vue?vue&type=script&lang=js&"
import style0 from "./Wap_CZY005_Step2.vue?vue&type=style&index=0&id=13656a36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13656a36",
  null
  
)

export default component.exports